import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { useLang } from "../context/LanguageContext";

export default function NotFound() {
  const { lang } = useLang();
  return (
    <>
      <Helmet>
        <title>{lang === "hi" ? "पेज नहीं मिला · Rihai" : "Page not found · Rihai"}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Nav />
      <main className="pt-40 pb-24 min-h-screen">
        <div className="container-x max-w-xl">
          <div className="overline mb-4">404</div>
          <h1 className="font-serif-display serif-textured text-5xl sm:text-6xl font-light leading-tight mb-4">
            {lang === "hi" ? "यह पेज नहीं मिला।" : "This page doesn't exist."}
          </h1>
          <p className="text-[#4A4640] text-lg mb-10">
            {lang === "hi"
              ? "शायद यह लिंक पुराना है — या हमारी गलती। नीचे से आगे बढ़िए।"
              : "The link may be old — or the mistake is ours. Move forward from below."}
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/" className="btn-primary">
              {lang === "hi" ? "मुख्य पृष्ठ पर वापस" : "Back to home"}
            </Link>
            <Link to="/blog" className="btn-secondary">
              {lang === "hi" ? "ब्लॉग पढ़िए" : "Read the journal"}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
